exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".galaxy\\:\\:common-canvas-editor-Gallery .blocks button svg{margin-left:auto;margin-right:auto;height:100%;width:auto}", ""]);

